angular.module("app").controller("GamesAddPageController", [
    '$scope',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'preloadedProviders',
    'casinoGameTypes',
    '$filter',
    'ratios',
    'pageStatuses',
    'logger',
    'settingsService',
    '$uibModalInstance',
    '$timeout',
    'countryCodes',
    'cacheService',
    'casinoJackpot',
    'casinoPaylines',
    'casinoVolatility',
    'preloadedFeatures',
    'preloadedThemes',
    'preloadedLicense',
    'preloadedGameData',
    'currencies',
    'Utils',
    function ($scope, $timeout, casinoGameService, errorHandler, preloadedCategories, preloadedProviders, casinoGameTypes, $filter, ratios, pageStatuses, logger, settingsService, $modalInstance,  $timeout, countryCodes, cacheService, casinoJackpot, casinoPaylines, casinoVolatility, preloadedFeatures, preloadedThemes, preloadedLicense, preloadedGameData, currencies, Utils) {
        var init,
            types = [],
            translator = $filter('translate'),
            settings = settingsService.getSettings(),
            addElementHelper = null;
        var countryNameCodeMap = {};
        var countryCodeNameMap = {};
        $scope.countryCodes = countryCodes.data.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            countryCodeNameMap[item["alpha-2"]] = item.name;
            return item.name;
        });

        var DEFAULT_LICENSE_ID = 3;
        casinoGameTypes.forEach(function (value) {
            types.push({
                id: value,
                title: translator('casinoGame.addEdit.types.' + value)
            })
        });

        function createLoadFunction(arr, i) {
            return function (data, result) {
                arr[i] = result;
                $timeout(function () {
                    $scope.$apply();
                }, 200);
            }
        }

        $scope.currencies = currencies.data;
        $scope.customRatioErrorContainer = {
            show: false
        };
        var categoryTitleIdMap = {};
        var categoryIdTitleMap = {};
        var casinoGameTypeIdMap = {};
        var casinoGameIdTypeMap = {};
        var themeTitleIdMap = {};
        var themeIdTitleMap = {};
        var featureTitleIdMap = {};
        var featureIdTitleMap = {};
        var licenseNameIdMap = {};
        var licenseIdNameMap = {};

        $scope.ratios = ratios;
        var tmpLanguages = [];

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.languages = tmpLanguages;

        $scope.pageStatuses = pageStatuses;

        $scope.uploadCache = {
            icons: [],
            icons2: [],
            licenseIcons:[],
            selectedLicenseIcon: 0,
            backgrounds: [],
            selectedIcon: 0,
            selectedIcon2: 0,
            selectedBackground: 0
        };

        $scope.tooltip = {
            height: "",
            width: "",
            downloadLinkWindows: "",
            downloadLinkLinux: "",
            downloadLinkMac: ""
        };

        $scope.paylines = angular.copy(casinoPaylines);
        $scope.volatility = angular.copy(casinoVolatility);
        $scope.jackpot = angular.copy(casinoJackpot);

        $scope.save = function () {
            if (!$scope.add_games_form.$valid) {
                $scope.customRatioErrorContainer.show = true;
                $scope.isSavePressed = true;
                return;
            }
            addElementHelper = $scope.useAddElementHelper();
            var requestData = {
                casinoGame: fetchRequestData ()
            };
            cacheService.set("selectedCategories", $scope.multiSelect.selectedCategories, 3600);
            cacheService.set("selectedCasinoGameTypes", $scope.multiSelect.selectedCasinoGameTypes, 3600);
            cacheService.set("blockedCurrencies", requestData.casinoGame.blocked_currencies, 3600);
            casinoGameService.create(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        addElementHelper.reset('gameNameTranslation');
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function fetchRequestData () {
            var fetchedData = angular.extend({}, $scope.gameData);
            fetchedData.categories = [];
            fetchedData.types = [];
            fetchedData.requestIcons = [];
            fetchedData.requestIcons2 = [];
            fetchedData.requestLicenseIcons = [];

            fetchedData.requestBackgrounds = [];
            fetchedData.blocked_countries = fetchedData.blocked_countries.map(function (value) {
               return countryNameCodeMap[value];
            });
            fetchedData.themes = [];
            fetchedData.features = [];
            fetchedData.licenses = [];
            fetchedData.is_mobile = fetchedData.is_mobile ? "1" : "0";
            fetchedData.is_mini_game = fetchedData.is_mini_game? "1": "0";
            fetchedData.justice =fetchedData.justice? "1": "0";
            fetchedData.manually =fetchedData.manually? "1": "0";

            $scope.gameData.icons.forEach(function (value, index) {
                fetchedData.requestIcons.push({
                    icon: value,
                    default: $scope.uploadCache.selectedIcon === index? "1" : "0"
                })
            });
            $scope.gameData.icons2.forEach(function (value, index) {
                fetchedData.requestIcons2.push({
                    icon: value,
                    default: $scope.uploadCache.selectedIcon2 === index? "1" : "0"
                })
            });
            $scope.gameData.licenseIcons.forEach(function (value, index) {
                fetchedData.requestLicenseIcons.push({
                    icon: value,
                    default: $scope.uploadCache.selectedLicenseIcon === index? "1" : "0",
                    license_id: DEFAULT_LICENSE_ID
                })
            });

            $scope.gameData.backgrounds.forEach(function (value, index) {
                fetchedData.requestBackgrounds.push({
                    icon: value,
                    default: $scope.uploadCache.selectedBackground === index? "1" : "0"
                })
            });

            fetchedData.translations = addElementHelper.fetchData('gameNameTranslation');
            $scope.multiSelect.selectedCategories.forEach(function (value) {
                fetchedData.categories.push(categoryTitleIdMap[value])
            });
            $scope.multiSelect.selectedCasinoGameTypes.forEach(function (value) {
                fetchedData.types.push(casinoGameTypeIdMap[value]);
            });
            $scope.multiSelect.selectedThemes.forEach(function (value) {
                fetchedData.themes.push(themeTitleIdMap[value]);
            });
            $scope.multiSelect.selectedFeatures.forEach(function (value) {
                fetchedData.features.push(featureTitleIdMap[value]);
            });
            $scope.multiSelect.selectedLicenses.forEach(function (value) {
                fetchedData.licenses.push(licenseNameIdMap[value]);
            });

            /*if(fetchedData.badge.value !== '0') {
                if (!fetchedData.badge.from && $scope.vm.dateTimeFrom) {
                    fetchedData.badge.from =  moment(new Date($scope.vm.dateTimeFrom)).tz("Asia/Yerevan").format()
                }
                if (!fetchedData.badge.to && $scope.vm.dateTimeTo) {
                    fetchedData.badge.to =  moment(new Date($scope.vm.dateTimeTo)).tz("Asia/Yerevan").format()
                }
            }*/

            return fetchedData
        }

        function initGameData(gameData) {
            var categories = [];

            $scope.multiSelect = {};


            $scope.multiSelect.casinoGameTypeTitles = types.map(function (item) {
                casinoGameTypeIdMap[item.title] = item.id;
                casinoGameIdTypeMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedCasinoGameTypes = gameData.types.map(function (item) {
                return casinoGameIdTypeMap[item];
            });
            $scope.multiSelect.categoryTitles = angular.copy(preloadedCategories).map(function (item) {
                categoryTitleIdMap[item.title] = item.id;
                categoryIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedCategories = gameData.categories.map(function (category) {
                return categoryIdTitleMap[category.id];
            });

            $scope.multiSelect.themeTitles = preloadedThemes.map(function (item) {
                themeTitleIdMap[item.title] = item.id;
                themeIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedThemes = (gameData.themes && (gameData.themes.map(function (item) {
                return themeIdTitleMap[item.id];
            }))) || [];

            $scope.multiSelect.featureTitles = preloadedFeatures.map(function (item) {
                featureTitleIdMap[item.title] = item.id;
                featureIdTitleMap[item.id] = item.title;
                return item.title;
            });
            $scope.multiSelect.selectedFeatures = (gameData.features && (gameData.features.map(function (item) {
                return featureIdTitleMap[item.id];
            }))) || [];

            $scope.multiSelect.licenseNames = preloadedLicense.map(function (item) {
                licenseNameIdMap[item.name] = item.id;
                licenseIdNameMap[item.id] = item.name;
                return item.name;
            });
            $scope.multiSelect.selectedLicenses = (gameData.licenses && (gameData.licenses.map(function (item) {
                return licenseIdNameMap[item];
            }))) || [];


            $scope.providers = angular.copy(preloadedProviders);

            gameData.front_game_id = gameData.provider + '' + gameData.server_game_id;

            //  gameData.categories = angular.copy(categories);

           /* var badgeValue = gameData.badge;
            gameData.badge = {
                value: badgeValue,
                from: gameData.badge_start_date,
                to: gameData.badge_end_date
            };

            $scope.preloadedBadge = gameData.badge;*/
            $scope.preloadedBlockedCountries = gameData.blocked_countries;
            $scope.gameData = angular.copy(gameData);
            delete $scope.gameData.id;
            delete $scope.gameData.extearnal_game_id;
            $scope.gameData.blocked_countries = $scope.gameData.blocked_countries && $scope.gameData.blocked_countries.map(function (value) {
                return countryCodeNameMap[value];
            }) || [];

            var iconsLength = $scope.gameData.icons.length;
            var icons = [];
            var counter = 0;
            for (var i = 0; i < iconsLength; ++i) {
                var icon = $scope.gameData.icons[i];
                if (icon.default === '1') {
                    $scope.uploadCache.selectedIcon = i;
                }
                var imageLink = icon['icon_3'];
                if (imageLink) {
                    Utils.getBlob(imageLink, createLoadFunction(icons, counter));
                    ++counter;
                }

            }
            $scope.gameData.icons = icons;

            var icons2Length = $scope.gameData.icons2.length;
            var icons2 = [];
            var counter = 0;
            for (var i = 0; i < icons2Length; ++i) {
                var icon = $scope.gameData.icons2[i];
                if (icon.default === '1') {
                    $scope.uploadCache.selectedIcon2 = i;
                }
                var imageLink = icon['icon_3'];
                if (imageLink) {
                    Utils.getBlob(imageLink, createLoadFunction(icons2, counter));
                    ++counter;
                }

            }
            $scope.gameData.icons2 = icons2;

            var licenseIconsLength = $scope.gameData.licenseIcons.length;
            var licenseIcons = [];
            var counter = 0;
            for (var i = 0; i < licenseIconsLength; ++i) {
                var icon = $scope.gameData.licenseIcons[i];
                if (icon.default === '1') {
                    $scope.uploadCache.selectedLicenseIcon = i;
                }
                var imageLink = icon['icon_3'];
                if (imageLink) {
                    Utils.getBlob(imageLink, createLoadFunction(licenseIcons, counter));
                    ++counter;
                }

            }
            $scope.gameData.licenseIcons = licenseIcons;

            var backgrounds = [];
            var backgroundsLength = $scope.gameData.backgrounds.length;
            for (var i = 0; i < backgroundsLength; ++i) {
                var background = $scope.gameData.backgrounds[i];
                if (background.default === '1') {
                    $scope.uploadCache.selectedBackground = i;
                }
                Utils.getBlob(background.background, createLoadFunction(backgrounds, i));

            }
            if (gameData.paytable){
                Utils.getBlob(gameData.paytable, function (_, res){
                    $scope.gameData.paytable = res;
                });
            }
            $scope.gameData.backgrounds = backgrounds;
         /*   if($scope.gameData.badge.value !== "0") {
                $scope.vm = {
                    dateTimeFrom:  gameData.badge.from && $filter("convertDateToUserTimezone")(moment(new Date(gameData.badge.from)).format('DD/MM/YYYY, HH:mm:ss'), 'DD/MM/YYYY, HH:mm:ss') || "",
                    dateTimeTo:  gameData.badge.to && $filter("convertDateToUserTimezone")(moment(new Date(gameData.badge.to)).format('DD/MM/YYYY, HH:mm:ss'), 'DD/MM/YYYY, HH:mm:ss') || "",
                    notFormat: true
                };
            }*/

            $scope.gameData.front_game_id = $scope.gameData.provider + '' + $scope.gameData.server_game_id;

            if (gameData.translations != undefined && gameData.translations.name != undefined) {
                $scope.gameNameTranslation = angular.copy(gameData.translations.name);
            }
            $scope.gameData.paylines = $scope.gameData.paylines || "";
            $scope.gameData.volatility = $scope.gameData.volatility || casinoVolatility[0].value;
            $scope.gameData.jackpot =  $scope.gameData.jackpot || casinoJackpot[0].value;
            $scope.gameData.is_mobile = $scope.gameData.is_mobile === "1";
            $scope.gameData.is_mini_game = $scope.gameData.is_mini_game === "1";
            $scope.gameData.justice = $scope.gameData.justice === "1";
            $scope.gameData.manually = $scope.gameData.manually === "1";
            $scope.gameData.blocked_currencies = $scope.gameData.blocked_currencies || [];
            $scope.gameData.showAsProvider = $scope.gameData.show_as_provider;
        }

        function loadExtraCategories(categoryId) {
            casinoGameService.getExtraCategories({category_id: categoryId}).then(function (response) {
                $scope.extraCategories = response.data;
                $scope.gameData.extra_category = response.data[0].value;
            });
        }

        $scope.changeCategory = function () {
            const selectedCategories = $scope.multiSelect.selectedCategories;

            if (selectedCategories && selectedCategories.length > 0) {
                const selectedCategoryTitle = selectedCategories.find((category) => category === 'Live Dealer' || category === 'Virtual Betting' || category === 'Skill Games');
                const categoryId = categoryTitleIdMap[selectedCategoryTitle];

                if (selectedCategoryTitle === 'Live Dealer' || selectedCategoryTitle === 'Virtual Betting' || selectedCategoryTitle === 'Skill Games') {
                    loadExtraCategories(categoryId);
                    $scope.showExtraCategory = true;
                } else {
                    $scope.showExtraCategory = false;
                    delete $scope.gameData.extra_category;
                }
            } else {
                $scope.showExtraCategory = false;
                delete $scope.gameData.extra_category;
            }
        };

        (init = function () {
            if (preloadedGameData) {
                initGameData(preloadedGameData);
                $scope.changeCategory();
                return;
            }
            $scope.multiSelect = {
                selectedCategories: [],
                selectedThemes: [],
                selectedFeatures: [],
                selectedLicenses: []
            };
            $scope.multiSelect.casinoGameTypeTitles = types.map(function (item) {
                casinoGameTypeIdMap[item.title] = item.id;
                return item.title;
            });
            $scope.multiSelect.categoryTitles = angular.copy(preloadedCategories).map(function (item) {
                categoryTitleIdMap[item.title] = item.id;
                categoryIdTitleMap[item.id] = item.title;
                return item.title;
            });
            var selectedCategories = cacheService.get("selectedCategories");
            if (selectedCategories) {
                $scope.multiSelect.selectedCategories = angular.copy(selectedCategories);
            }else {
                $scope.multiSelect.selectedCategories.push(categoryIdTitleMap["65"]);
            }

            var selectedCasinoGameTypes = cacheService.get("selectedCasinoGameTypes");
            if (selectedCasinoGameTypes) {
                $scope.multiSelect.selectedCasinoGameTypes = selectedCasinoGameTypes;
            } else{
                $scope.multiSelect.selectedCasinoGameTypes = [];
            }

            $scope.multiSelect.themeTitles = preloadedThemes.map(function (item) {
                themeTitleIdMap[item.title] = item.id;
                return item.title;
            });
            $scope.multiSelect.featureTitles = preloadedFeatures.map(function (item) {
                featureTitleIdMap[item.title] = item.id;
                return item.title;
            });

            $scope.multiSelect.licenseNames = preloadedLicense.map(function (item) {
                licenseNameIdMap[item.name] = item.id;
                return item.name;
            });

            $scope.providers = angular.copy(preloadedProviders);

            $scope.gameData = {
                description: "",
                name: "",
                height: undefined,
                width: undefined,
                provider: $scope.providers[0].name,
                showAsProvider: $scope.providers[0].name,
                ratio: ratios[2].value,
                status: pageStatuses[0],
                paylines: "",
                volatility: casinoVolatility[0].value,
                jackpot: casinoJackpot[0].value,
                backgrounds: [],
                blocked_countries: [],
                server_game_id: '',
                icons: [],
                icons2: [],
                licenseIcons:[],
                is_mobile: false,
                is_mini_game: false,
                justice: false,
                manually: false,
                blocked_currencies: cacheService.get("blockedCurrencies") || []
            };

            $scope.gameData.front_game_id = $scope.gameData.provider + '' + $scope.gameData.server_game_id;

            $scope.add_games_form && $scope.add_games_form.$setPristine();

            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };
            $scope.changeCategory();
        })();

        $scope.deleteIconOrBackground = function (data, flug) {
            if (flug === 'background') {
                $scope.gameData.backgrounds.splice(data, 1);
                if($scope.uploadCache.selectedBackground === data) {
                    $scope.uploadCache.selectedBackground = 0
                } else if ($scope.uploadCache.selectedBackground > data){
                    $scope.uploadCache.selectedBackground -= 1;
                }
            }
            else if (flug === 'icons') {
                $scope.gameData.icons.splice(data, 1);
                $scope.uploadCache.selectedIcon = 0;
                if($scope.uploadCache.selectedIcon === data) {
                    $scope.uploadCache.selectedIcon = 0;
                } else if($scope.uploadCache.selectedIcon > data) {
                    $scope.uploadCache.selectedIcon -= 1;
                }

            }  else if (flug === 'licenseIcons') {
                $scope.gameData.licenseIcons.splice(data, 1);
                $scope.uploadCache.selectedLicenseIcon = 0;
                if($scope.uploadCache.selectedLicenseIcon === data) {
                    $scope.uploadCache.selectedLicenseIcon = 0;
                } else if($scope.uploadCache.selectedLicenseIcon > data) {
                    $scope.uploadCache.selectedLicenseIcon -= 1;
                }

            } else if (flug === 'icons2') {
                $scope.gameData.icons2.splice(data, 1);
                $scope.uploadCache.selectedIcon2 = 0;
                if($scope.uploadCache.selectedIcon2 === data) {
                    $scope.uploadCache.selectedIcon2 = 0;
                } else if($scope.uploadCache.selectedIcon2 > data) {
                    $scope.uploadCache.selectedIcon2 -= 1;
                }

            }

        };

  /*      $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.gameData.badge.from = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.gameData.badge.to = $scope.vm.toDate;
            }
        };
        
        $scope.setBadgeDate = function (badge) {

            $scope.vm = {
                dateTimeFrom: '',
                dateTimeTo: ''
            };

            if (badge !== '0') {
                $scope.vm = {
                    dateTimeFrom: moment(new Date()).format('DD/MM/YYYY, HH:mm:ss'),
                    dateTimeTo: moment(new Date()).add('1','month').format('DD/MM/YYYY, HH:mm:ss'),
                    notFormat: true
                };
            }
        };*/

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.resetMiniGameOptions = function () {
            if ($scope.gameData.is_mini_game) {
                $scope.gameData.mini_game_options = "";
            }
        };

        $scope.$watch('uploadCache.icon', function () {
            if ($scope.uploadCache.icon && angular.isString($scope.uploadCache.icon)) {
                $scope.gameData.icons.push($scope.uploadCache.icon);
                $scope.uploadCache.icon = false;
            }
        });
        $scope.$watch('uploadCache.icon2', function () {
            if ($scope.uploadCache.icon2 && angular.isString($scope.uploadCache.icon2)) {
                $scope.gameData.icons2.push($scope.uploadCache.icon2);
                $scope.uploadCache.icon2 = false;
            }
        });
        $scope.$watch('uploadCache.licenseIcon', function () {
            if ($scope.uploadCache.licenseIcon && angular.isString($scope.uploadCache.licenseIcon)) {
                $scope.gameData.licenseIcons.push($scope.uploadCache.licenseIcon);
                $scope.uploadCache.licenseIcon = false;
            }
        });

        $scope.$watch('uploadCache.background', function () {
            if ($scope.uploadCache.background && angular.isString($scope.uploadCache.background)) {
                $scope.gameData.backgrounds.push($scope.uploadCache.background);
                $scope.uploadCache.background = false;
            }
        });
    }
]);
